import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

// Models
import { Server } from '@models/narobial/server';

@Injectable()
export class ServerService {
  // Rutas.
  readonly URL_API = '/api/narobial/servers/';
  private protocol = 'https://';

  constructor(private http: HttpClient) {}

  public getServers(url: string): Observable<Object> {
    return this.http.get(this.protocol + url + this.URL_API + 'all');
  }

  public getServersById(url: string, id: string): Observable<Object> {
    return this.http.get(this.protocol + url + this.URL_API + 'byid/' + id);
  }

  // GET: Obtener servidor.
  public getServersByDmsCode(url: string, id: string): Observable<Object> {
    return this.http.get(this.protocol + url + this.URL_API + 'bydmscode/' + id);
  }

  // GET: Agregar servidor.
  public addServer(url: string, server: Server): Observable<Object> {
    return this.http.post(this.protocol + url + this.URL_API, server);
  }

  // GET: Editar servidor.
  public editServer(url: string, server: Server): Observable<Object> {
    return this.http.put(this.protocol + url + this.URL_API, server);
  }

  // GET: Eliminar servidor.
  public deleteServer(url: string, _id: String): Observable<Object> {
    return this.http.delete(this.protocol + url + this.URL_API + `${_id}`);
  }
}
